<script setup>
import { useApi } from '@/composables/useApi';
import { watch } from 'vue';

const { updatePhotos } = useApi()

const emit = defineEmits();

const photoArray = defineModel();

const props = defineProps({
	petId: String,
})

const handleFileChange = event => {
	if (photoArray.value.length + event.target.files.length <= 4)
		Array.from(event.target.files).forEach(element => photoArray.value.push(element));
}

watch(
	() => photoArray.value,
	() => {
		console.log(photoArray.value);
		updatePhotos(props.petId, photoArray.value);
		emit('updatePhotos', photoArray.value.length);
	},
	{ deep: true }
);
</script>

<template>
	<label class="photo-input-wr" :class="{ disabled: !petId }">
		<span>Загрузить фото питомца до процедуры</span>
		<span>(макс.4. до 10Мб., JPEG, PNG)</span>
		<input
			id="photo-input"
			type="file"
			accept="image/png, image/jpeg, image/jpg"
			multiple
			:disabled="!petId"
			@change="handleFileChange"
		>
	</label>
</template>

<style lang='scss'>
.photo-input-wr {
	width: 100%;
	height: 120px;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	padding: 18px 16px;
	cursor: pointer;
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%239D9E9EFF' stroke-width='4' stroke-dasharray='10%2c 10' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");
	border-radius: 12px;
	background-color: #FFF;

	&.disabled { opacity: .5 }

	span {
		display: block;
		font-size: 16px;
		font-weight: 500;
		color: #BABABA;
		line-height: 23px;

		&:last-of-type {
			font-size: 12px;
			margin-right: 6px;
			align-self: flex-end;

			&::after {
				width: 20px;
				height: 17px;
				position: relative;
				top: 2px;
				margin-left: 8px;
				content: '';
				display: inline-block;
				background-image: url('public/icons/camera.svg');
			}
		}
	}

	input { display: none }
}
</style>